import { addresses } from '../../addresses'
import abi from './abi'

export const ZoraCreatorMerkleMinterStrategy = {
  abi,
  address: addresses.ZORA_1155.MERKLE_MINT_SALE_STRATEGY,
} as const
